import { FlexBox, Skeleton, Table } from '@dixa/lib-shared-habla';
import { FC } from 'react';

import placeholderStyles from './placeholders.module.scss';

/** Placeholders for the articles table */
export function ArticlesViewPlaceholder(): JSX.Element {
  return (
    <Table
      headerWithBackground
      framed
      wrapperProps={{ className: placeholderStyles.table }}
    >
      <Table.Thead>
        <Table.Tr
          style={{
            lineHeight: '16px',
            color: 'var(--dixa-color-neutral-200)',
          }}
        >
          <Table.Th>
            <Skeleton height="16px" width="16px" animation="wave" />
          </Table.Th>
          <Table.Th>
            <Skeleton height="12px" width="12px" animation="wave" />
          </Table.Th>
          <Table.Th>
            <Skeleton height="12px" width="32px" animation="wave" />
          </Table.Th>
          <Table.Th />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {Array.from(Array(30)).map((_, index) => (
          <ArticleTablePlaceholderRow key={index} />
        ))}
      </Table.Tbody>
    </Table>
  );
}
export const ArticleTablePlaceholderRow: FC = () => (
  <Table.Tr
    style={{
      lineHeight: '16px',
      color: 'var(--dixa-color-neutral-200)',
    }}
  >
    <Table.Td>
      <FlexBox flexDirection="column" gap="4px">
        <Skeleton height="16px" width="160px" animation="wave" />
        <FlexBox alignItems="center">
          <Skeleton height="12px" width="100px" animation="wave" /> •{' '}
          <Skeleton height="12px" width="100px" animation="wave" />
        </FlexBox>
      </FlexBox>
    </Table.Td>
    <Table.Td>
      <FlexBox flexDirection="column" gap="4px">
        <Skeleton height="16px" width="80px" animation="wave" />
        <Skeleton height="12px" width="60px" animation="wave" />
      </FlexBox>
    </Table.Td>
    <Table.Td>
      <Skeleton height="24px" width="100px" animation="wave" />
    </Table.Td>
    <Table.Td />
  </Table.Tr>
);
